import { createAction } from '@reduxjs/toolkit';
import { alertActions } from '_actions';
import { errorReportService } from '_services';
import { ActionNames, Errors } from '_constants'

export const errorReportActions = {

    send: (userMsg, error = undefined, info = undefined) => (dispatch, getState) => {
        if (!getState().ui.errorReport.submitting && !getState().ui.errorReport.lastErno) {
            dispatch(errorReportActions.sendRequest());

            errorReportService.send(error, info, userMsg)
                .then(
                    response => {
                        dispatch(errorReportActions.sendSuccess({ response }));
                    }
                    ,
                    error => {
                        dispatch(errorReportActions.sendFailure({ error }));
                        dispatch(alertActions.error(Errors.ERROR_REPORT_FAILURE));
                    }
                );
        }
    },
    sendRequest: createAction(ActionNames.SEND_ERROR_REPORT_REQUEST),
    sendSuccess: createAction(ActionNames.SEND_ERROR_REPORT_SUCCESS),
    sendFailure: createAction(ActionNames.SEND_ERROR_REPORT_FAILURE),

}
